export function applyCepResponseToForm($j, $form, dados) {
  const $endereco = $form.find("#params_endereco");
  const $cep = $form.find("#params_cep");
  const $bairro = $form.find("#params_bairro");
  const $compl = $form.find("#params_complemento");

  if ($endereco.length && dados.street !== undefined) {
    $endereco.val(dados.street).trigger("input").trigger("change");
  }
  if ($cep.length && dados.zipcode !== undefined) {
    $cep.val(dados.zipcode).trigger("input").trigger("change");
  }
  if ($bairro.length && dados.neighborhood !== undefined) {
    $bairro.val(dados.neighborhood).trigger("input").trigger("change");
  }
  if ($compl.length && (dados.complement !== undefined || dados.complemento !== undefined)) {
    $compl.val(dados.complement || dados.complemento).trigger("input").trigger("change");
  }

  // município: prefere o nome oficial da tabela municipios (via codigo_ibge), fallback para city
  const municipioNome = dados.municipio_nome || dados.city
  if (municipioNome) {
    const $muni =
      $form.find("#autocomplete_admissao_municipio").first().length ? $form.find("#autocomplete_admissao_municipio").first() :
        $form.find("#admissao_municipio").first().length ? $form.find("#admissao_municipio").first() :
          $form.find("#params_municipio").first().length ? $form.find("#params_municipio").first() :
            $form.find('input[name*="municipio"]').first();

    if ($muni && $muni.length) {
      // Desativa temporariamente o widget autocomplete para evitar que trigger("input")
      // dispare uma busca assíncrona que pode conflitar com o valor preenchido.
      try { $muni.autocomplete("disable") } catch (_) {}
      $muni.val(municipioNome)
      $muni.trigger("input").trigger("change")
      try { $muni.autocomplete("enable") } catch (_) {}
    }
  }
}
